import {ChangeDetectorRef, Component, Input, OnInit} from "@angular/core";
import {ControlContainer, NgForm} from "@angular/forms";
import {ConteudoRim} from "../../../../core/conteudo-rim";
import {ConsultaBanco} from "../../../../core/consulta-banco";
import {ConsultaBancoService} from "../../../../services/consulta-banco/consulta-banco.service";
import {ConteudoCabecalhoTabelaRim} from "../../../../core/conteudo-cabecalho-tabela-rim";
import {ConsultaColunaBanco} from "../../../../core/consulta-coluna-banco";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {LarguraColunaTabelaDialogComponent} from "../editar-largura-coluna-tabela-dialog/largura-coluna-tabela-dialog.component";
import {EditarCabecalhoTabelaDialogComponent} from "../editar-cabecalho-tabela-dialog/editar-cabecalho-tabela-dialog.component";
import {ConfirmDialogComponent} from "../../../common/confirm-dialog/confirm-dialog.component";
import {ActivatedRoute} from "@angular/router";
import {ConteudoColunaRim} from "src/app/core/conteudo-coluna-rim";

@Component({
    selector: "conteudo-tabela-rim",
    templateUrl: "./conteudo-tabela-rim.component.html",
    styleUrls: ["./conteudo-tabela-rim.component.css"],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}],
})
export class ConteudoTabelaRimComponent implements OnInit {

    @Input() conteudo: ConteudoRim;
    @Input() index: number;
    @Input() camposDesabilitados: boolean;
    @Input() isEditando: boolean;
    @Input() consultasBanco: ConsultaBanco[];

    pinRandom = Math.random();

    colunasTabela: ConsultaColunaBanco[] = [];
    colunasTabelaSelecionadas: ConsultaColunaBanco[] = [];
    larguraTotal: number;

    cabecalhoSelecionado: ConteudoCabecalhoTabelaRim | null = null;
    cabecalhoSelecionadoSegundo: ConteudoCabecalhoTabelaRim | null = null;

    linhaTabela: ConteudoCabecalhoTabelaRim[][] = [];

    // Propriedade para verificar alterações
    private _previousContentState: string;

    constructor(private drc: ChangeDetectorRef,
                private consultaBancoService: ConsultaBancoService,
                private dialog: MatDialog,
                private activatedRoute: ActivatedRoute) {
    }

    ngOnInit(): void {
        this.carregarColunasTabela();
        this.conteudo.cabecalhosTabela.forEach(l => {
            l.merged = l.extensaoLinha < 0;
            l.exibir = l.extensaoLinha > 0;
        });

        if (!this.conteudo.cabecalhosTabela.some(cabecalho => cabecalho.tipoDado !== "C")) {
            this.carregarTabela();
        }

        // Inicializar o estado anterior do conteúdo
        this._previousContentState = this.getContentStateSignature();
    }

    ngDoCheck(): void {
        // Verifica se o conteúdo foi alterado
        const currentState = this.getContentStateSignature();
        if (currentState !== this._previousContentState) {
            this._previousContentState = currentState;

            // Se o conteúdo foi alterado, atualiza a tabela
            if (!this.conteudo.cabecalhosTabela.some(cabecalho => cabecalho.tipoDado !== "C")) {
                this.carregarTabela();
            }
        }
    }

    // Método para gerar uma assinatura do estado atual do conteudo
    private getContentStateSignature(): string {
        if (!this.conteudo || !this.conteudo.cabecalhosTabela) {
            return '';
        }

        return JSON.stringify({
            consultaBancoId: this.conteudo.consultaBanco?.id,
            cabecalhosCount: this.conteudo.cabecalhosTabela.length,
            tiposDados: this.conteudo.cabecalhosTabela.map(c => c.tipoDado).join('')
        });
    }

    ngAfterContentChecked(): void {
    }

    onValorChangeConsultaBanco(registro: any) {
        this.conteudo.consultaBanco = registro;
        this.conteudo.colunas = [];
        this.colunasTabelaSelecionadas = [];
        this.conteudo.cabecalhosTabela = [];

        this.linhaTabela = [];

        this.carregarColunasTabela();
        this.carregarTabela();
    }

    private carregarColunasTabela() {
        if (!this.conteudo.colunas)
            this.conteudo.colunas = [];
        if (!this.conteudo.cabecalhosTabela)
            this.conteudo.cabecalhosTabela = [];

        if (this.conteudo.consultaBanco?.id) {
            this.consultaBancoService.getById(this.conteudo.consultaBanco.id).subscribe((consultaBanco: ConsultaBanco) => {
                this.colunasTabela = consultaBanco.colunas;

                if (this.consultasBanco) {
                    for(let coluna of this.colunasTabela){
                        let valor = coluna.nome;
                        let matches = [...new Set(valor.match(/#{(.*?)}/g) || [])];
                        matches.forEach(match => {
                            const key = match.slice(2, -1);
                            const textoValor = this.consultasBanco.find(value => value.codigo === key).valor?.texto;
                            valor = valor.replace(new RegExp(match, 'g'), textoValor);
                            coluna.nome = valor;
                        });
                    }
                }

                this.conteudo.colunas?.forEach(coluna => {
                    if (!this.colunasTabelaSelecionadas.some(item => item.id === coluna.consultaColunaBanco.id)) {
                        this.colunasTabelaSelecionadas.push(consultaBanco.colunas.find(item => item.id === coluna.consultaColunaBanco.id));
                    }
                });

                if (this.colunasTabelaSelecionadas.length === 0) {
                    this.colunasTabelaSelecionadas = this.colunasTabela;
                }
                this.conteudo.colunas.sort((a, b) => {
                    return a.posicao - b.posicao;
                });


                this.popularColunasTabelaSelecionadas();
                this.atualizarLarguraTotal();
                this.processarLinhaTabela();
            });
        }
    }

    onValorChangeConsultaColunaBanco() {
        for (let i = 0; i < this.conteudo.colunas.length; i++) {
            if (!this.colunasTabelaSelecionadas.find(item => item.id === this.conteudo.colunas[i].consultaColunaBanco.id)) {
                this.conteudo.colunas.splice(i, 1);
                i--;
                this.conteudo.colunas.forEach((item, index) => item.posicao = index + 1);
            }
        }

        this.popularColunasTabelaSelecionadas();
        this.processarLinhaTabela();
    }

    private popularColunasTabelaSelecionadas() {
        this.colunasTabelaSelecionadas.forEach(item => {
            if (!this.conteudo.colunas.find(coluna => coluna.consultaColunaBanco.id === item.id)) {
                if (this.linhaTabela.length > 0 && this.conteudo.colunas.length <= 0) {
                    this.conteudo.cabecalhosTabela.forEach(l => l.posicaoLinha++);
                }
                let conteudoColunaRim = new ConteudoColunaRim();
                conteudoColunaRim.consultaColunaBanco = item;
                conteudoColunaRim.descricao = item.nome;
                conteudoColunaRim.alinhamento = 'L';
                conteudoColunaRim.posicao = this.conteudo.colunas.length + 1;
                // conteudoColunaRim.largura = 100;
                conteudoColunaRim.largura = this.calcularLarguraBaseadaEmTexto(item.nome);

                this.conteudo.colunas.push(conteudoColunaRim);
            }
        });
    }

    /**
     * Calcula a largura da coluna baseada no tamanho do texto
     */
    private calcularLarguraBaseadaEmTexto(texto: string): number {
        if (!texto) return 100;

        // Largura mínima padrão
        const larguraMinima = 80;
        // Largura máxima permitida para uma coluna
        const larguraMaxima = 200;
        // Fator de multiplicação para estimar a largura (aproximadamente 8 pixels por caractere)
        const fatorLargura = 2;

        // Calcula a largura baseada no comprimento do texto
        let larguraCalculada = texto.length * fatorLargura;

        // Aplica os limites mínimo e máximo para a coluna individual
        larguraCalculada = Math.min(Math.max(larguraCalculada, larguraMinima), larguraMaxima);

        return larguraCalculada;
    }

    selecionarCelula(cabecalho: ConteudoCabecalhoTabelaRim) {
        if (!cabecalho) {
            this.cabecalhoSelecionado = null;
            this.cabecalhoSelecionadoSegundo = null;
            return;
        }

        if (this.cabecalhoSelecionado === cabecalho || this.cabecalhoSelecionadoSegundo === cabecalho) {
            this.abrirDialogDescricaoCabecalho();
            return;
        }

        if (!this.cabecalhoSelecionado) {
            this.cabecalhoSelecionado = cabecalho;
        } else if (!this.cabecalhoSelecionadoSegundo) {
            this.cabecalhoSelecionadoSegundo = cabecalho;
        } else {
            this.cabecalhoSelecionado = cabecalho;
            this.cabecalhoSelecionadoSegundo = null;
        }
    }

    isSelected(cabecalho: ConteudoCabecalhoTabelaRim): boolean {
        return (this.cabecalhoSelecionado === cabecalho) ||
            (this.cabecalhoSelecionadoSegundo === cabecalho);
    }

    mergeCells() {
        if (!this.cabecalhoSelecionado || !this.cabecalhoSelecionadoSegundo) return;

        const {posicaoLinha: row1, posicaoColuna: col1} = this.cabecalhoSelecionado;
        const {posicaoLinha: row2, posicaoColuna: col2} = this.cabecalhoSelecionadoSegundo;

        if (row1 === row2 && col1 === col2) {
            alert('Selecione células diferentes.');
            return;
        }

        // Verifica se o merge é válido na linha ou coluna
        if (row1 !== row2 && col1 !== col2) {
            alert('O merge só pode ser feito na mesma linha ou na mesma coluna.');
            return;
        }

        // Caso seja um merge na linha
        if (row1 === row2) {
            this.mergeHorizontal(row1, col1, col2);
        }
        // Caso seja um merge na coluna
        else if (col1 === col2) {
            this.mergeVertical(col1, row1, row2);
        }

        this.cabecalhoSelecionado = null;
        this.cabecalhoSelecionadoSegundo = null;
    }

    private mergeHorizontal(row: number, colStart: number, colEnd: number) {
        if (colStart > colEnd) {
            let temp = colStart;
            colStart = colEnd;
            colEnd = temp;
        }

        let extensao = 0;
        for (let i = colStart; i <= colEnd; i++) {
            if (this.linhaTabela[row][i].merged)
                continue;

            if (extensao === 0) {
                extensao = this.linhaTabela[row][i].extensaoLinha;
            } else if (extensao !== this.linhaTabela[row][i].extensaoLinha) {
                alert('Não é possível mesclar células com tamanhos diferentes.');
                return;
            }
        }

        for (let i = colStart + 1; i <= colEnd; i++) {
            this.linhaTabela[row][i].merged = true;
            this.linhaTabela[row][i].exibir = false;
            this.linhaTabela[row][i].descricao = '';
            this.linhaTabela[row][i].extensaoLinha = -1;
        }
        this.linhaTabela[row][colStart].extensaoColuna += colEnd - colStart;
    }

    private mergeVertical(col: number, rowStart: number, rowEnd: number) {
        if (rowStart > rowEnd) {
            let temp = rowStart;
            rowStart = rowEnd;
            rowEnd = temp;
        }

        let extensao = 0;
        for (let i = rowStart; i <= rowEnd; i++) {
            if (this.linhaTabela[i][col].merged)
                continue;

            if (extensao === 0) {
                extensao = this.linhaTabela[i][col].extensaoColuna;
            } else if (extensao !== this.linhaTabela[i][col].extensaoColuna) {
                alert('Não é possível mesclar células com tamanhos diferentes.');
                return;
            }
        }

        for (let i = rowStart + 1; i <= rowEnd; i++) {
            this.linhaTabela[i][col].merged = true;
            this.linhaTabela[i][col].exibir = false;
            this.linhaTabela[i][col].descricao = '';
            this.linhaTabela[i][col].extensaoLinha = -1;
        }
        this.linhaTabela[rowStart][col].extensaoLinha = rowEnd - rowStart + 1;
    }

    private processarLinhaTabela() {
        if (this.conteudo.cabecalhosTabela?.length > 0) {
            this.conteudo.cabecalhosTabela.forEach(l => {
                l.merged = l.extensaoLinha < 0;
                if (this.colunasTabelaSelecionadas.some(c => c.id === l.consultaColunaBanco?.id))
                    l.posicaoColuna = this.colunasTabelaSelecionadas.findIndex(c => c.id === l.consultaColunaBanco.id);
                if (l.tipoDado !== "H" && l.tipoDado !== "F" && !this.colunasTabelaSelecionadas.some(c => c.id === l.consultaColunaBanco?.id) || l.merged) {
                    l.exibir = false;
                } else {
                    if (!l.exibir)
                        l.posicaoColuna = this.colunasTabelaSelecionadas.length;
                    l.exibir = true;
                }
            });
            const maxColuna = this.colunasTabelaSelecionadas.length;
            this.conteudo.cabecalhosTabela.forEach(l => {
                if (l.tipoDado === "H" || l.tipoDado === "F") {
                    l.extensaoColuna = maxColuna;
                }
            });

            this.linhaTabela = [];
            let linhasExistentes = this.conteudo.cabecalhosTabela.map(cabecalho => cabecalho.posicaoLinha);
            linhasExistentes = linhasExistentes.filter((item, index) => linhasExistentes.indexOf(item) === index);
            linhasExistentes.sort((a, b) => a - b);

            for (let i = 0; i < linhasExistentes.length; i++) {
                const linha = this.conteudo.cabecalhosTabela.filter(cabecalho => cabecalho.posicaoLinha === linhasExistentes[i])
                    .sort((a, b) => a.posicaoColuna - b.posicaoColuna);
                this.linhaTabela.push(linha);

                if (linha[0].tipoDado !== "S") {
                    let itemOpcao = new ConteudoCabecalhoTabelaRim();
                    itemOpcao.descricao = 'Opção ' + (i + 1);
                    itemOpcao.posicaoLinha = linhasExistentes[i];
                    itemOpcao.posicaoColuna = this.conteudo.cabecalhosTabela.length > 0 ? this.conteudo.cabecalhosTabela.map(cabecalho => cabecalho.posicaoColuna).reduce((a, b) => Math.max(a, b), 0) + 1 : 0;
                    itemOpcao.extensaoLinha = 1;
                    itemOpcao.extensaoColuna = 1;
                    itemOpcao.tipoDado = "O";
                    itemOpcao.exibir = true;
                    this.linhaTabela[i].push(itemOpcao);
                }
            }
        }
    }

    chamaCaixaDialogoRemoverLinha(linha: ConteudoCabecalhoTabelaRim) {
        const dialogConfig = {
            data: {
                pergunta: "Remover Linha",
                textoAuxiliar: "Deseja realmente remover a linha?",
                textoConfirma: "Sim",
                textoCancela: "Não",
            }
        };

        this.dialog.open(ConfirmDialogComponent, dialogConfig).afterClosed().subscribe((confirma) => {
            if (confirma) {
                this.conteudo.cabecalhosTabela = this.conteudo.cabecalhosTabela.filter(l => l.posicaoLinha !== linha.posicaoLinha);
                this.processarLinhaTabela();
            }
        });
    }

    chamaCaixaDialogoAdicionarLinha(linha: ConteudoCabecalhoTabelaRim) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            pergunta: "Adicionar Linha",
            textoAuxiliar: "Deseja a adicionart a linha abaixo ou acima?",
            textoConfirma: "Abaixo",
            textoCancela: "Acima",
        };

        this.dialog.open(ConfirmDialogComponent, dialogConfig).afterClosed().subscribe((confirma) => {
            this.adicionarLinha(confirma ? linha.posicaoLinha + 1 : linha.posicaoLinha);
        });
    }

    adicionarLinha(posicaoLinha: number) {
        this.selecionarCelula(null);
        let linhaHeader = [];
        let posicao = 0;
        this.conteudo.cabecalhosTabela.filter(l => l.posicaoLinha >= posicaoLinha).forEach(l => l.posicaoLinha++);
        this.conteudo.colunas.forEach((item) => {
            let cabecalho = new ConteudoCabecalhoTabelaRim();
            cabecalho.descricao = item.descricao;
            cabecalho.alinhamento = item.alinhamento;
            cabecalho.corFundoCabecalho = "#FFFFFF";
            cabecalho.posicaoLinha = posicaoLinha;
            cabecalho.posicaoColuna = posicao++;
            cabecalho.extensaoColuna = 1;
            cabecalho.extensaoLinha = 1;
            cabecalho.merged = false;
            cabecalho.tipoDado = "C";
            cabecalho.bold = true;
            cabecalho.consultaColunaBanco = item.consultaColunaBanco;
            linhaHeader.push(cabecalho);
        });
        this.conteudo.cabecalhosTabela.push(...linhaHeader);
        this.processarLinhaTabela();
    }

    abrirDialogLarguraColuna() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            larguraTotal: this.larguraTotal,
            conteudo: this.conteudo,
        };

        const dialogRef = this.dialog.open(LarguraColunaTabelaDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(() => dialogRef.close());
    }

    abrirDialogDescricaoCabecalho() {
        let colunas = this.conteudo.colunas.filter(coluna => this.cabecalhoSelecionado.posicaoLinha === this.conteudo.cabecalhosTabela.length
            && coluna.posicao === this.cabecalhoSelecionado.posicaoColuna + 1);
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            larguraTotal: this.larguraTotal,
            cabecalhoSelecionado: this.cabecalhoSelecionado,
            colunas: colunas,
        };

        const dialogRef = this.dialog.open(EditarCabecalhoTabelaDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(() => dialogRef.close());
        this.selecionarCelula(null);
    }

    private getLarguraTotal(listaColuna: any[]): number {
        return listaColuna.reduce((total, col) => total + col.largura, 0);
    }

    private atualizarLarguraTotal(): void {
        this.larguraTotal = this.getLarguraTotal(this.conteudo.colunas);
    }

    chamaCaixaDialogoRecarregarTabela() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            pergunta: "Recarregar dados da Tabela",
            textoAuxiliar: "Deseja realmente recarregar os dados da tabela?",
            textoConfirma: "Sim",
            textoCancela: "Não",
        };

        this.dialog.open(ConfirmDialogComponent, dialogConfig).afterClosed().subscribe((confirma) => {
            if (confirma) {
                this.carregarTabela();
            }
        });
    }

    private carregarTabela() {
        const id = this.activatedRoute.snapshot.queryParams.id || null;
        if (this.conteudo.consultaBanco?.id && id) {
            this.consultaBancoService.carregarTabela(this.conteudo.consultaBanco.id, id).subscribe((linhasCorpo: ConteudoCabecalhoTabelaRim[]) => {
                this.conteudo.cabecalhosTabela = [];

                let adicionarTitulo = true;
                let linhasAdds = 0;
                if (linhasCorpo.length > 0) {
                    for (let i = 0; i < linhasCorpo.length; i++) {
                        const cabecalho = linhasCorpo[i];
                        if (cabecalho.tipoDado === "H") {
                            adicionarTitulo = true;
                        }
                        if (cabecalho.tipoDado !== "H" && adicionarTitulo) {
                            this.gerarTituloTabela(cabecalho.posicaoLinha + linhasAdds);
                            linhasAdds++;
                            adicionarTitulo = false;
                        }

                        cabecalho.posicaoLinha += linhasAdds;
                        this.conteudo.cabecalhosTabela.push(cabecalho);
                    }
                } else {
                    this.gerarTituloTabela(0);
                }
                this.conteudo.cabecalhosTabela.forEach(l => l.exibir = true);



                if (this.consultasBanco) {
                  for(let cabecalho of this.conteudo.cabecalhosTabela){
                      let valor = cabecalho.descricao;
                      let matches = [...new Set(valor.match(/#{(.*?)}/g) || [])];
                      matches.forEach(match => {
                        const key = match.slice(2, -1);
                        const textoValor = this.consultasBanco.find(value => value.codigo === key).valor?.texto;
                        valor = valor.replace(new RegExp(match, 'g'), textoValor);
                        cabecalho.descricao = valor;
                      });
                  }
                }

                this.processarLinhaTabela();
                this.corrigirLarguraColunas();
            });
        }
    }

    private corrigirLarguraColunas() {
        this.conteudo.colunas.forEach(coluna => {
            // Buscar todos os cabecalhos relacionados a esta coluna
            const dados = this.conteudo.cabecalhosTabela.filter(
                cabecalho => cabecalho.consultaColunaBanco?.id === coluna.consultaColunaBanco.id
            );

            // Iniciar com a largura baseada no título da coluna
            let larguraOtima = coluna.largura;

            // Se existirem dados, calcular a largura média baseada no conteúdo
            if (dados.length > 0) {
                // Calcular a largura baseada em cada valor e encontrar o máximo
                const larguraDados = dados
                    .map(cabecalho => this.calcularLarguraBaseadaEmTexto(cabecalho.descricao))
                    .reduce((max, largura) => Math.max(max, largura), 0);

                // Usar a maior largura entre o título e os dados
                larguraOtima = Math.max(larguraOtima, larguraDados);
            }

            // Atribuir a largura calculada à coluna
            coluna.largura = larguraOtima;
        });
        this.atualizarLarguraTotal();
        if (this.larguraTotal > 565) {
            // Ajustar a largura de todas as colunas para caber na tabela
            const fatorAjuste = 565 / this.larguraTotal;
            this.conteudo.colunas.forEach(col => {
                col.largura = Math.max(10, Math.floor(col.largura * fatorAjuste));
            });
            this.atualizarLarguraTotal();
        }
    }

    private gerarTituloTabela(numLinha) {
        this.colunasTabelaSelecionadas.forEach((item, index) => {
            let c = new ConteudoCabecalhoTabelaRim();
            c.descricao = item.nome;
            c.alinhamento = 'L';
            c.corFundoCabecalho = "#FFFFFF";
            c.posicaoLinha = numLinha;
            c.posicaoColuna = index;
            c.extensaoColuna = 1;
            c.extensaoLinha = 1;
            c.merged = false;
            c.tipoDado = "T";
            c.consultaColunaBanco = item;
            c.bold = true;
            this.conteudo.cabecalhosTabela.push(c);
        });
    }

    // Add these methods to your component class

    /**
     * Determines if a cell should be displayed
     */
    shouldShowCell(item: any): boolean {
        return !(
            item.merged ||
            item.extensaoLinha < 0 ||
            !item.exibir ||
            (!this.isEditando && item.tipoDado === 'O')
        ) || (item.tipoDado === 'S' && this.conteudo.agruparTabela);
    }

    /**
     * Returns the cell's styles based on its properties
     */
    getCellStyles(item: any): object {
        return {
            'text-align': item.alinhamento === 'L' ? 'left' :
                item.alinhamento === 'C' ? 'center' : 'right',
            'padding-left': '0px',
            'padding-right': '0px',
            'background-color': item.corFundoCabecalho,
            'min-height': '15px',
            'font-weight': item.bold ? 'bold' : 'normal',
            'font-style': item.italic ? 'italic' : 'normal',
            'border': '1px solid black',
            'border-left': item.tipoDado !== 'S' ? '1px solid black' : '1px solid transparent',
            'border-right': item.tipoDado !== 'S' ? '1px solid black' : '1px solid transparent',
            'cursor': this.isEditando && item.tipoDado !== 'S' ? 'pointer' : 'default'
        };
    }

    /**
     * Handles cell click based on edit state and cell type
     */
    handleCellClick(item: any): void {
        if (this.isEditando && item.tipoDado !== 'S') {
            this.selecionarCelula(item);
        }
    }

    /**
     * Determines if action buttons should be displayed
     */
    showActionButtons(item: any): boolean {
        return this.isEditando && !this.camposDesabilitados && item.tipoDado === 'O';
    }

}